import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  MenuController,
  Loading,
  LoadingController,
} from "ionic-angular";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastController } from "ionic-angular";

import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";

import { AppStore } from "./../../store/AppStore";
import {
  LoginAction,
  LoginKeyAction,
  ResetPasswordRequestAction,
  LogoutAction,
} from "../../store/action/UserActions";

import { ForgotPasswordPage } from "../forgot-password/forgot-password";
import { environment } from "../../environments/environment";
import { UserService } from "./../../services/UserService";

import _ from "lodash";
import { CronosProjectsPage } from "../cronos-projects/cronos-projects";
import { DocrenPage } from "../docren/docren";

@IonicPage()
@Component({
  selector: "page-login",
  templateUrl: "login.html",
})
export class LoginPage {
  public form: FormGroup;
  public organizationLogo: string = null;
  public organizationName: string = null;
  public usingAccessKey: boolean = false;
  public submitted: boolean = false;
  public isLoading: boolean = false;
  public isLoggingIn: boolean = false;
  public loader: Loading;

  public users: any = [];

  private userStateSubscription: Subscription;

  public version: string = environment.VERSION;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public menuController: MenuController,
    private store: Store<AppStore>,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.loadFormDefault();
    this.checkByEmail();
  }

  ionViewDidLoad() {
    this.menuController.enable(false);
    this.menuController.swipeEnable(false);
    this.isLoggingIn = false;
  }

  ionViewDidEnter() {
    this.userStateSubscription = this.store
      .select("userState")
      .subscribe((userState) => {
        this.isLoading = userState.loading;
        if (userState.error && !userState.loading) {
          this.presentToast("Usuário ou senha inválidos");
        }
        if (userState.authenticated) {
          if (this.isLoggingIn == true) {
            const decodedToken = this.decodeToken(userState.token);
            const expirationDate = new Date(decodedToken.exp * 1000);
            localStorage.setItem(
              "expirationDate",
              JSON.stringify(expirationDate)
            );
            this.isLoggingIn = false;
          }
          const timer = JSON.parse(localStorage.getItem("expirationDate"));
          if (timer && Date.now() > timer) {
            localStorage.removeItem("expirationDate");
            this.store.dispatch(new LogoutAction());
            this.navCtrl.setRoot(LoginPage);
          } else {
            this.menuController.enable(true);
            this.menuController.swipeEnable(true);

            if (this.checkIsDownload()) {
              this.navCtrl.setRoot(DocrenPage, this.checkIsDownload());
              return;
            }

            this.navCtrl.setRoot(CronosProjectsPage);
          }
        }
        if (userState.organization != null) {
          this.organizationName = userState.organization.nomeFantasia;
          this.organizationLogo = userState.organization.logo;
        }
      });
  }

  checkIsDownload() {
    const url = new URL(window.location.href);
    const fileId = url.searchParams.get("file");

    if (!fileId) return;

    const userId = url.searchParams.get("user");
    return { fileId, userId };
  }

  private decodeToken(token: string): any {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    const decodedToken = JSON.parse(window.atob(base64));
    return decodedToken;
  }

  ionViewWillLeave() {
    if (this.userStateSubscription != null) {
      this.userStateSubscription.unsubscribe();
    }
  }

  loadFormDefault(): void {
    this.form = this.formBuilder.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
      usuario: [null, Validators.required],
      accessKey: [null],
    });
  }

  loadFormAccessKey(): void {
    this.form = this.formBuilder.group({
      email: [""],
      password: [""],
      usuario: [null],
      accessKey: [null, Validators.required],
    });
  }

  changeToAccessKey(): void {
    this.usingAccessKey = !this.usingAccessKey;
    if (this.usingAccessKey) {
      this.loadFormAccessKey();
    } else {
      this.loadFormDefault();
    }
    this.submitted = false;
  }

  checkByEmail = (function () {
    var timer = 0;
    return function () {
      window.clearTimeout(timer);
      this.users = [];
      this.form.controls.usuario.value = null;
      if (!this.form.controls.email.value.match(/\w+@\w+\.\w{2,}\.?\w{0,}/g))
        return;

      timer = window.setTimeout(() => {
        this.findUserByEmail({ email: this.form.controls.email.value || "" });
      }, 1000);
    };
  })();

  findUserByEmail(usuario: any): void {
    this.createLoader("Aguarde...", true);
    this.userService.findUserByEmail(usuario).subscribe((data) => {
      this.checkUser(data || []);
    });
    this.createLoader("", false);
  }

  checkUser(users: any): void {
    if (!users.length) {
      this.presentToast("Usuário ou senha inválidos");
      return;
    }
    if (users.length == 1) {
      this.users = [];
      this.form.controls.usuario.patchValue(
        _.assign({}, users[0], { senha: null })
      );
      return;
    }
    this.users = users;
  }

  logIn(): void {
    this.submitted = true;
    if (this.form.valid) {
      this.isLoggingIn = true;
      if (this.usingAccessKey) {
        let key: any = this.form.controls.accessKey.value;
        this.store.dispatch(new LoginKeyAction({ key: key }));
      } else {
        if (
          !this.checkClientEnabled(
            this.form.controls.usuario.value.clientEnabled
          )
        )
          return;
        let password: any = this.form.controls.password.value;
        this.form.controls.usuario.value.senha = password;
        this.store.dispatch(
          new LoginAction({ user: this.form.controls.usuario.value })
        );
      }
    }
  }

  private checkClientEnabled(isEnabled: boolean): boolean {
    if (!isEnabled)
      this.presentToast("Cliente inativo. Contate o administrador do sistema.");

    return isEnabled;
  }

  startResetPassword(): void {
    this.store.dispatch(new ResetPasswordRequestAction());
    this.navCtrl.push(ForgotPasswordPage);
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "top",
    });
    toast.present();
  }

  createLoader(message: string, create: boolean): void {
    if (!create) {
      this.loader.dismiss();
      this.loader = null;
      return;
    }

    if (this.loader == null) {
      this.loader = this.loadingCtrl.create({ content: message });
      this.loader.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts